import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-neutral-500",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-green-500",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createBlock(_component_Switch, {
    modelValue: _ctx.valueData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueData) = $event)),
    class: _normalizeClass([
			_ctx.valueData ? 'bg-green-500' : 'bg-neutral-500',
			'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500',
		])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", {
        class: _normalizeClass([
				_ctx.valueData ? 'translate-x-5' : 'translate-x-0',
				'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
			])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([
					_ctx.valueData
						? 'opacity-0 ease-out duration-100'
						: 'opacity-100 ease-in duration-200',
					'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
				]),
          "aria-hidden": "true"
        }, _hoisted_3, 2),
        _createElementVNode("span", {
          class: _normalizeClass([
					_ctx.valueData
						? 'opacity-100 ease-in duration-200'
						: 'opacity-0 ease-out duration-100',
					'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
				]),
          "aria-hidden": "true"
        }, _hoisted_5, 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}